/* istanbul ignore file */

export enum EditorContext {
  PAGE = 'page',
  MEDIA = 'media',
}
